import { clsx } from 'clsx'
import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { useProductStockStatus } from '../../hooks/useProductStockStatus'
import { useShowProductDeliveryDates } from '../../hooks/useShowProductDeliveryDates'

export const ProductBuyBoxStockStatus: FC = () => {
  const productStockStatus = useProductStockStatus()
  const shouldShowDeliveryDates = useShowProductDeliveryDates()

  return (
    <span
      className={clsx('font-medium', productStockStatus.color)}
      data-qa-id="product-status-qa-id"
    >
      <div className="py-1">
        {shouldShowDeliveryDates ? (
          <FormattedMessage id="general.label.product.availableDays" />
        ) : (
          (productStockStatus.message ?? (
            <FormattedMessage id="general.label.product.available" />
          ))
        )}
      </div>
    </span>
  )
}
